import { Button } from "design-system/atoms/Button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "design-system/molecules/DropdownMenu"
import { Ellipsis, Trash } from "lucide-react"
import { useDeleteApiTokenMutation } from "modules/settings/hooks/useDeleteApiTokenMutation"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

type Props = {
  id: string
}

export function ApiTokenDropdown({ id }: Props) {
  const { t } = useTranslation()
  const { mutateAsync, isPending } = useDeleteApiTokenMutation()

  async function onDeleteApiToken() {
    await mutateAsync(id)
    toast.success(t("settings.keysAndSecrets.apiTokens.deleteSuccess"))
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          title={t("settings.keysAndSecrets.apiTokens.actions")}
          disabled={isPending}
        >
          <Ellipsis size={20} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem asChild onClick={onDeleteApiToken}>
          <div className="flex flex-row gap-2 items-center">
            <Trash size={16} />
            {t("settings.keysAndSecrets.apiTokens.delete")}
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
